import { Answer } from "./Answer";
import { Question } from "./Question";
import { QuestionIllustration } from "./QuestionIllustration";
import { QuizCountry } from "./QuizCountry";

export class WorldQuiz 
{
    private _questions: Array<Question> = [];

    constructor()
    {
        this._questions =
            [
                new Question("What is the Statue of Liberty? ",
                    [
                        new Answer("A famous waterfall", false),
                        new Answer("A large mountain", false),
                        new Answer("A famous statue in New York", true),
                        new Answer("A popular amusement park ride", false),
                    ],
                    QuestionIllustration.StatueOfLiberty,
                    QuizCountry.USA
                ),
                new Question("Where is the Statue of Liberty located? ",
                    [
                        new Answer("San Francisco, California ", false),
                        new Answer("Washington, D.C.", false),
                        new Answer("Miami, Florida", false),
                        new Answer("New York City, New York", true),
                    ],
                    QuestionIllustration.StatueOfLiberty,
                    QuizCountry.USA
                ),
                new Question("What does the Statue of Liberty hold in her right hand? ",
                    [
                        new Answer("A torch", true),
                        new Answer("A book", false),
                        new Answer("A crown", false),
                        new Answer("A flag", false),
                    ],
                    QuestionIllustration.StatueOfLiberty,
                    QuizCountry.USA
                ),
                new Question("What is Mount Rushmore? ",
                    [
                        new Answer("A famous mountain in Australia", false),
                        new Answer("A popular beach in Hawaii ", false),
                        new Answer("A monument with giant sculptures in the United States", true),
                        new Answer("A historical castle in Europe", false),
                    ],
                    QuestionIllustration.MountRushmore,
                    QuizCountry.USA
                ),
                new Question("Where is Mount Rushmore located? ",
                    [
                        new Answer("California ", false),
                        new Answer("New York", false),
                        new Answer("South Dakota", true),
                        new Answer("Texas", false),
                    ],
                    QuestionIllustration.MountRushmore,
                    QuizCountry.USA
                ),
                new Question("Where can you find the famous pyramids? ",
                    [
                        new Answer("Rome, Italy", false),
                        new Answer("Paris, France", false),
                        new Answer("Giza, Egpyt", true),
                        new Answer("Istanbul, Turkey", false),
                    ],
                    QuestionIllustration.Pyramids,
                    QuizCountry.Egypt
                ),
                new Question("Who built the pyramids in Egypt? ",
                    [
                        new Answer("Aliens from outer space", false),
                        new Answer("Ancient Egyptians", true),
                        new Answer("Wizards and magicians", false),
                        new Answer("Dinosaurs", false),
                    ],
                    QuestionIllustration.Pyramids,
                    QuizCountry.Egypt
                ),
                new Question("What material was commonly used to build the pyramids?",
                    [
                        new Answer("Wood", false),
                        new Answer("Straw", false),
                        new Answer("Stone", true),
                        new Answer("Bricks", false),
                    ],
                    QuestionIllustration.Pyramids,
                    QuizCountry.Egypt
                ),
                new Question("What is the famous river in Egypt associated with mummies? ",
                    [
                        new Answer("Amazon River ", false),
                        new Answer("Nile River ", true),
                        new Answer("Mississippi River", false),
                        new Answer("River Thames", false),
                    ],
                    QuestionIllustration.Mummies,
                    QuizCountry.Egypt
                ),
                new Question("What is the name of the most famous boy king mummy discovered in Egypt?",
                    [
                        new Answer("Tutankhamun", true),
                        new Answer("Cleopatra", false),
                        new Answer("Ramses", false),
                        new Answer("Nefertiti", false),
                    ],
                    QuestionIllustration.Mummies,
                    QuizCountry.Egypt
                ),
                new Question("Which civilization is famous for mummies?",
                    [
                        new Answer("Ancient Greece", false),
                        new Answer("Inca Empire ", false),
                        new Answer("Ancient Egypt", true),
                        new Answer("Roman Empire", false),
                    ],
                    QuestionIllustration.Mummies,
                    QuizCountry.Egypt
                ),
                new Question("What famous structures did the pharaohs build?",
                    [
                        new Answer("Pyramids", true),
                        new Answer("Skycrapers", false),
                        new Answer("Castles", false),
                        new Answer("Windmills", false),
                    ],
                    QuestionIllustration.Mummies,
                    QuizCountry.Egypt
                ),
                new Question("Where are camels typically found? ",
                    [
                        new Answer("Rainforests", false),
                        new Answer("Deserts", true),
                        new Answer("Polar region", false),
                        new Answer("The ocean", false),
                    ],
                    QuestionIllustration.Camels,
                    QuizCountry.Egypt
                ),
                new Question("Where can you find the Great Sphinx?",
                    [
                        new Answer("Rome, Italy", false),
                        new Answer("Athens, Greece", false),
                        new Answer("Giza, Egypt", true),
                        new Answer("Istanbul, Turkey", false),
                    ],
                    QuestionIllustration.Sphinx,
                    QuizCountry.Egypt
                ),
                new Question("What is the Sphinx?",
                    [
                        new Answer("Mythological figure with a lion's body and human head", true),
                        new Answer("A tall tower in Paris", false),
                        new Answer("A type of bird found in the rainforest", false),
                        new Answer("A famous singer", false),
                    ],
                    QuestionIllustration.Sphinx,
                    QuizCountry.Egypt
                ),
                new Question("What is the Sphinx made of?",
                    [
                        new Answer("Gold", false),
                        new Answer("Stone", true),
                        new Answer("Chocolate", false),
                        new Answer("Paper", false),
                    ],
                    QuestionIllustration.Sphinx,
                    QuizCountry.Egypt
                ),
                new Question("What is sushi?",
                    [
                        new Answer("A type of fish with wheels", false),
                        new Answer("A Japanese dish made with raw fish and rice", true),
                        new Answer("A dance move popular among sushi chefs", false),
                        new Answer("A breed of Japanese cat", false)
                    ],
                    QuestionIllustration.Sushi,
                    QuizCountry.Japan
                ),
                new Question("Which country is sushi originally from? ",
                    [
                        new Answer("China", false),
                        new Answer("Japan", true),
                        new Answer("Mexico", false),
                        new Answer("Brazil", false),
                    ],
                    QuestionIllustration.Sushi,
                    QuizCountry.Japan
                ),
                new Question("How do you eat sushi with chopsticks? ",
                    [
                        new Answer("By using them as drumsticks", false),
                        new Answer("By poking your friend with them ", false),
                        new Answer("By picking up the sushi gently", true),
                        new Answer("By putting them up your nose", false),
                    ],
                    QuestionIllustration.Sushi,
                    QuizCountry.Japan
                ),
                new Question("What is the main ingredient in sushi? ",
                    [
                        new Answer("Rice", true),
                        new Answer("Chocolate", false),
                        new Answer("Ice cream", false),
                        new Answer("Ketchup", false),
                    ],
                    QuestionIllustration.Sushi,
                    QuizCountry.Japan
                ),

                // Sumo

                new Question("What is Sumo?",
                    [
                        new Answer("A Japanese martial art", true),
                        new Answer("A type of dance ", false),
                        new Answer("A popular card game", false),
                        new Answer("A type of food", false),
                    ],
                    QuestionIllustration.Sumo,
                    QuizCountry.Japan
                ),
                new Question("How do sumo wrestlers train to become strong? ",
                    [
                        new Answer("By eating lots of ice cream", false),
                        new Answer("By doing yoga and meditation", true),
                        new Answer("By lifting weights and practicing sumo techniques", false),
                        new Answer("By eating spinach", false),
                    ],
                    QuestionIllustration.Sumo,
                    QuizCountry.Japan
                ),
                new Question("How do sumo wrestlers show respect before a match? ",
                    [
                        new Answer("By giving each other a high five", false),
                        new Answer("By bowing to each other", true),
                        new Answer("By playing rock-paper-scissors", false),
                        new Answer("By dancing together", false),
                    ],
                    QuestionIllustration.Sumo,
                    QuizCountry.Japan
                ),
                new Question("Which country is Tokyo located in? ",
                    [
                        new Answer("China", false),
                        new Answer("Japan", true),
                        new Answer("South Korea", false),
                        new Answer("India", false),
                    ],
                    QuestionIllustration.Tokyo,
                    QuizCountry.Japan
                ),
                new Question("What is the capital city of Japan? ",
                    [
                        new Answer("Osaka", false),
                        new Answer("Kyoto", false),
                        new Answer("Tokyo ", true),
                        new Answer("Shanghai", false),
                    ],
                    QuestionIllustration.Tokyo,
                    QuizCountry.Japan
                ),
                new Question("What is the famous tower in Tokyo called? ",
                    [
                        new Answer("Eiffel Tower", false),
                        new Answer("Tokyo Tower", true),
                        new Answer("Big Ben", false),
                        new Answer("Leaning Tower of Pisa", false),
                    ],
                    QuestionIllustration.Tokyo,
                    QuizCountry.Japan
                ),
                new Question("What is the popular mode of transportation in Tokyo? ",
                    [
                        new Answer("Tuk-tuk", false),
                        new Answer("Bullet train", true),
                        new Answer("Hot air balloon", false),
                        new Answer("Taxi", false),
                    ],
                    QuestionIllustration.MountFuji,
                    QuizCountry.Japan
                ),
                new Question("What is Mount Fuji often covered with?",
                    [
                        new Answer("Snow", true),
                        new Answer("Sand", false),
                        new Answer("Grass", false),
                        new Answer("Flowers", false),
                    ],
                    QuestionIllustration.MountFuji,
                    QuizCountry.Japan
                ),
                new Question("What is the Sydney Opera House? ",
                    [
                        new Answer("A famous shopping centre ", false),
                        new Answer("A popular beach ", false),
                        new Answer("An iconic performing arts venue in Australia ", true),
                        new Answer("A historical museum", false)
                    ],
                    QuestionIllustration.SydneyOperaHouse,
                    QuizCountry.Australia
                ),
                new Question("Where is the Sydney Opera House located? ",
                    [
                        new Answer("New York City, USA ", false),
                        new Answer("London, England ", false),
                        new Answer("Sydney, Australia ", true),
                        new Answer("Paris, France", false)
                    ],
                    QuestionIllustration.SydneyOperaHouse,
                    QuizCountry.Australia
                ),
                new Question("What is the shape of the Sydney Opera House's roof? ",
                    [
                        new Answer("Pyramid ", false),
                        new Answer("Dome", false),
                        new Answer("Spiral", false),
                        new Answer("Shell-like sails", true)
                    ],
                    QuestionIllustration.SydneyOperaHouse,
                    QuizCountry.Australia
                ),
                new Question("Which animal is known for carrying its baby in a pouch?",
                    [
                        new Answer("Kangaroo", true),
                        new Answer("Giraffe", false),
                        new Answer("Lion", false),
                        new Answer("Elephant", false)
                    ],
                    QuestionIllustration.Animals,
                    QuizCountry.Australia
                ),
                new Question("Which animal is famous for its ability to jump long distances?",
                    [
                        new Answer("Wombat", false),
                        new Answer("Kangaroo", true),
                        new Answer("Koala", false),
                        new Answer("Tasmanian Devil", false)
                    ],
                    QuestionIllustration.Animals,
                    QuizCountry.Australia
                ),
                new Question("Where are koalas native to?",
                    [
                        new Answer("Africa", false),
                        new Answer("South America", false),
                        new Answer("Australia", true),
                        new Answer("Europe", false)
                    ],
                    QuestionIllustration.Animals,
                    QuizCountry.Australia
                ),
                new Question("How do koalas spend most of their time?",
                    [
                        new Answer("Swimming in rivers ", false),
                        new Answer("Climbing trees ", true),
                        new Answer("Burrowing underground ", false),
                        new Answer("Running on land", false)
                    ],
                    QuestionIllustration.Animals,
                    QuizCountry.Australia
                ),
                new Question("What is the climate like on the Australian Gold Coast? ",
                    [
                        new Answer("Cold and snowy", false),
                        new Answer("Hot and humid", false),
                        new Answer("Cool and rainy", false),
                        new Answer("Mild and sunny", true)
                    ],
                    QuestionIllustration.GoldCoast,
                    QuizCountry.Australia
                ),
                new Question("What is the Australian Gold Coast known for?",
                    [
                        new Answer("Famous vineyards", false),
                        new Answer("Skiing and snowboarding", false),
                        new Answer("Beautiful beaches and surfing", true),
                        new Answer("Dense rainforests", false)
                    ],
                    QuestionIllustration.GoldCoast,
                    QuizCountry.Australia
                ),
                new Question("Where is the Gold Coast located? ",
                    [
                        new Answer("California, USA", false),
                        new Answer("Queensland, Australia", true),
                        new Answer("Dubai, United Arab Emirates", false),
                        new Answer("Rio de Janeiro, Brazil", false)
                    ],
                    QuestionIllustration.GoldCoast,
                    QuizCountry.Australia
                ),
                new Question("Which country is known for maple syrup and ice hockey? ",
                    [
                        new Answer("Mexico", false),
                        new Answer("Canada", true),
                        new Answer("China", false),
                        new Answer("Brazil", false),
                    ],
                    QuestionIllustration.IceHockey,
                    QuizCountry.Canada
                ),
                new Question("What sport is played on ice with players wearing skates and using sticks?",
                    [
                        new Answer("Football ", false),
                        new Answer("Basketball ", false),
                        new Answer("Ice hockey", true),
                        new Answer("Baseball", false),
                    ],
                    QuestionIllustration.IceHockey,
                    QuizCountry.Canada
                ),
                new Question("What is a small, circular piece of hard rubber called that players use to play ice hockey?",
                    [
                        new Answer("Paddle", false),
                        new Answer("Stick", false),
                        new Answer("Ball", false),
                        new Answer("Puck", true),
                    ],
                    QuestionIllustration.IceHockey,
                    QuizCountry.Canada
                ),
                new Question("What is the capital city of Canada?",
                    [
                        new Answer("Montreal", false),
                        new Answer("Vancouver", false),
                        new Answer("Toronto", false),
                        new Answer("Ottawa", true),
                    ],
                    QuestionIllustration.Toronto,
                    QuizCountry.Canada
                ),
                new Question("Which famous tower is a landmark in Toronto? ",
                    [
                        new Answer("Eiffel Tower", false),
                        new Answer("Sydney Opera House", false),
                        new Answer("Burj Khalifa", false),
                        new Answer("CN Tower", true),
                    ],
                    QuestionIllustration.Toronto,
                    QuizCountry.Canada
                ),
                new Question("Which sport is popular in Toronto? ",
                    [
                        new Answer("Football", false),
                        new Answer("Baseball ", false),
                        new Answer("Cricket ", false),
                        new Answer("Ice hockey", true),
                    ],
                    QuestionIllustration.Toronto,
                    QuizCountry.Canada
                ),
                new Question("What is a moose?",
                    [
                        new Answer("A type of bird", false),
                        new Answer("A large mammal", true),
                        new Answer("A reptile", false),
                        new Answer("A fish", false),
                    ],
                    QuestionIllustration.Moose,
                    QuizCountry.Canada
                ),
                new Question("Where are moose commonly found? ",
                    [
                        new Answer("Deserts", false),
                        new Answer("Oceans", false),
                        new Answer("Forests", true),
                        new Answer("Mountains", false),
                    ],
                    QuestionIllustration.Moose,
                    QuizCountry.Canada
                ),
                new Question("Which of the following best describes a moose's antlers? ",
                    [
                        new Answer("Soft and furry", false),
                        new Answer("Spiky and colorful", false),
                        new Answer("Small and round", false),
                        new Answer("Large and branched", true),
                    ],
                    QuestionIllustration.Moose,
                    QuizCountry.Canada
                ),
                new Question("Where is the Eiffel Tower located? ",
                    [
                        new Answer("London, England", false),
                        new Answer("Paris, France", true),
                        new Answer("Rome, Italy", false),
                        new Answer("Barcelona, Spain", false),
                    ],
                    QuestionIllustration.EiffelTower,
                    QuizCountry.France
                ),
                new Question("How tall is the Eiffel Tower? ",
                    [
                        new Answer("100 meters ", false),
                        new Answer("300 meters", true),
                        new Answer("500 meters", false),
                        new Answer("700 meters", false),
                    ],
                    QuestionIllustration.EiffelTower,
                    QuizCountry.France
                ),
                new Question("What is the Eiffel Tower made of? ",
                    [
                        new Answer("Stone", false),
                        new Answer("Wood", false),
                        new Answer("Glass", false),
                        new Answer("Iron", true),
                    ],
                    QuestionIllustration.EiffelTower,
                    QuizCountry.France
                ),
                new Question("Who painted the Mona Lisa?",
                    [
                        new Answer("Leonardo DiCaprio ", false),
                        new Answer("Michelangelo ", false),
                        new Answer("Leonardo da Vinci ", true),
                        new Answer("Vincent van Gogh", false),
                    ],
                    QuestionIllustration.MonoLisa,
                    QuizCountry.France
                ),
                new Question("In which country can you find the Mona Lisa? ",
                    [
                        new Answer("Italy", false),
                        new Answer("France", true),
                        new Answer("Spain", false),
                        new Answer("United States", false),
                    ],
                    QuestionIllustration.MonoLisa,
                    QuizCountry.France
                ),
                new Question("What is the Mona Lisa's famous expression? ",
                    [
                        new Answer("Laughing", false),
                        new Answer("Crying", false),
                        new Answer("Smiling", true),
                        new Answer("Angry", false),
                    ],
                    QuestionIllustration.MonoLisa,
                    QuizCountry.France
                ),
                new Question("Which museum is the home of the Mona Lisa? ",
                    [
                        new Answer("Louvre Museum ", true),
                        new Answer("Metropolitan Museum of Art ", false),
                        new Answer("British Museum ", false),
                        new Answer("Guggenheim Museum", false),
                    ],
                    QuestionIllustration.MonoLisa,
                    QuizCountry.France
                ),
                new Question("Where is the Notre Dame Cathedral located? ",
                    [
                        new Answer("London, England", false),
                        new Answer("Rome, Italy", false),
                        new Answer("Paris, France", true),
                        new Answer("Barcelona, Spain", false),
                    ],
                    QuestionIllustration.NotraDame,
                    QuizCountry.France
                ),
                new Question("What style of architecture is the Notre Dame Cathedral known for?",
                    [
                        new Answer("Gothic", true),
                        new Answer("Modern", false),
                        new Answer("Renaissance", false),
                        new Answer("Romanesque", false),
                    ],
                    QuestionIllustration.NotraDame,
                    QuizCountry.France
                ),
                new Question("What is the famous bell inside the Notre Dame Cathedral called? ",
                    [
                        new Answer("Big Ben", false),
                        new Answer("Liberty Bell ", false),
                        new Answer("Notre Dame Bell ", false),
                        new Answer("Emmanuel Bell", true),
                    ],
                    QuestionIllustration.NotraDame,
                    QuizCountry.France
                ),
                new Question("What is the name of the famous cathedral in Paris?",
                    [
                        new Answer("Notre Dame Cathedral", true),
                        new Answer("St. Paul's Cathedral", false),
                        new Answer("Westminster Abbey", false),
                        new Answer("Sagrada Familia", false),
                    ],
                    QuestionIllustration.NotraDame,
                    QuizCountry.France
                ),
                new Question("What is the Tower of London?",
                    [
                        new Answer("A famous clock tower", false),
                        new Answer("A royal palace", false),
                        new Answer("A historic fortress", true),
                        new Answer("A shopping mall", false),
                    ],
                    QuestionIllustration.TowerOfLondon,
                    QuizCountry.UK
                ),
                new Question("Where is the Tower of London located?",
                    [
                        new Answer("Paris, France", false),
                        new Answer("Rome, Italy", false),
                        new Answer("London, England", true),
                        new Answer("New York, USA", false),
                    ],
                    QuestionIllustration.TowerOfLondon,
                    QuizCountry.UK
                ),
                new Question("What is the purpose of the Tower of London?",
                    [
                        new Answer("To house the crown jewels", false),
                        new Answer("To serve as a prison", false),
                        new Answer("To protect the city", false),
                        new Answer("All the above", true),
                    ],
                    QuestionIllustration.TowerOfLondon,
                    QuizCountry.UK
                ),
                new Question("Where is Windsor Castle located?",
                    [
                        new Answer("Windsor, England", true),
                        new Answer("Paris, France", false),
                        new Answer("Rome, Italy", false),
                        new Answer("Barcelona, Spain", false),
                    ],
                    QuestionIllustration.WindsorCastle,
                    QuizCountry.UK
                ),

                new Question("What is the main function of Windsor Castle?",
                    [
                        new Answer("A royal residence", true),
                        new Answer("A shopping centre", false),
                        new Answer("A museum", false),
                        new Answer("A school ", false),
                    ],
                    QuestionIllustration.WindsorCastle,
                    QuizCountry.UK
                )
            ];
    }

    public get questions(): Array<Question> { return this._questions; }
}